/**
 * @generated SignedSource<<9761e80f8836b131e4733066d08fd7c7>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type DesignerDirectoryWrapper_viewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryContent_viewer" | "DesignerDirectoryHeader_viewer">;
  readonly " $fragmentType": "DesignerDirectoryWrapper_viewer";
};
export type DesignerDirectoryWrapper_viewer$key = {
  readonly " $data"?: DesignerDirectoryWrapper_viewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"DesignerDirectoryWrapper_viewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "DesignerDirectoryWrapper_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesignerDirectoryHeader_viewer"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "DesignerDirectoryContent_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};

(node as any).hash = "a58e90722b2966162826cf4824a24e8a";

export default node;
